import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fordeldConfig: TSPConfig = {
  key: 'fordeld',
  name: 'Ford ELD',
  imageName: 'FordELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Ford ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default fordeldConfig;
